/** `DEVICE_REVOKED`. Local state is already wiped by the time this renders; this explains why. */

import { useNavigate } from 'react-router';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { selectSession } from '@pos/shared';

import { useAppSelector } from '@/app/hooks';

export function DeviceRevokedPage() {
  const navigate = useNavigate();
  const { revokedReason } = useAppSelector(selectSession);

  return (
    <Stack sx={{ minHeight: '100dvh', justifyContent: 'center', alignItems: 'center', px: 3 }}>
      <Card variant="outlined" sx={{ maxWidth: 460, borderRadius: 'var(--pos-radius-card)' }}>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            This device was signed out
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
            {revokedReason ??
              'This account was signed in on another device, so this session ended. Sign in with your password to continue.'}
          </Typography>

          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
            Everything stored locally has been cleared.
          </Typography>

          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 3 }}
            onClick={() => void navigate('/sign-in', { replace: true })}
          >
            Sign in with password
          </Button>
        </CardContent>
      </Card>
    </Stack>
  );
}
